import React from 'react';
import Swal from 'sweetalert2';
import _ from 'lodash';
import axios from 'axios';
import socketIOClient from 'socket.io-client';
import toastr from 'toastr';
import store from '../store';
import {
  getMyRegion
} from '../ultil.js';

import {
  getOrderDetailForShop
} from '../store/action/orderActionRedux'

class SocketManager {
  constructor() {
    this.socketURL = `https://shop-socket.heyu.asia/shop`;
    this.hasConnect = false;
    this.socket = null;
  }

  init() {
    this.socket = socketIOClient(this.socketURL, {
      transports: ['websocket'],
      jsonp: false,
      reconnection: true,
      query: {
        region: getMyRegion(),
        mode: 'shop',
      },
    })

    this.socket.on('reconnect_attempt', () => {
      if (this.socket) {
        this.socket.io.opts.query = {
          region: getMyRegion(),
          mode: 'shop',
        };
      }
    });

    this.socket.on('connect', data => {
      // console.log('socket: connect', data);
      this.hasConnect = true;
      this.login();
    });

    this.socket.on('connect_error', err => {
      // console.log('socket: connect_error');
      this.socket = null;
      this.hasConnect = false;
    });

    this.socket.on('order_type_change', (data, cb) => {
      // console.log('socket: order_type_change', data);
    });

    this.socket.on('current_shipper', (data, cb) => {
      typeof cb === 'function' && cb();
    });

    this.socket.on('profile_update', (data, cb) => {
    });

    this.socket.on('order_take', (data, cb) => {
      // console.log('socket: order_take', data);
      typeof cb === 'function' && cb();
    });

    this.socket.on('order_reject', (data, cb) => {
      // console.log('socket: order_reject', data);
      typeof cb === 'function' && cb();
    });
    this.socket.on('order_update_customer', (data, cb) => {
      console.log('socket: order_reject', data);
      typeof cb === 'function' && cb();
    });
    this.socket.on('order_update', (data, cb) => {
      // console.log('socket: order_update', data);
      store.dispatch(getOrderDetailForShop(data.data.extras.id))
      this.showNotify(data)
      typeof cb === 'function' && cb();
    });

    this.socket.on('order_bike_take', (data, cb) => {
      // console.log('socket: order_bike_take', data);
      typeof cb === 'function' && cb();
    });

    this.socket.on('order_bike_reject', (data, cb) => {
      // console.log('socket: order_bike_reject', data);
      typeof cb === 'function' && cb();
    });

    this.socket.on('order_bike_update', (data, cb) => {
      // console.log('socket: order_bike_update', data);
    });

    this.socket.on('disconnect', () => {
      // console.log('socket: disconnect');
    });
  }

  showNotify(data, type = 'info'){
    if (data.description || data.title) {
      // toastr[type](data.description, data.title)
      Swal.fire({
        title: data.title,
        text: data.description,
        imageUrl: '/icon.png',
        imageWidth: 60,
        imageHeight: 60,
        imageAlt: 'Alert Image',
        confirmButtonText: 'OK',
      }).then((result) => {
      })
    }
  }

  getSocket() {
    return this.socket;
  }

  reCheck() {
    if (!this.socket || !this.socket.connected) {
      this.destroy();
      const memberToken = _.get(localStorage, 'access_token', '');
      const role = _.get(localStorage, 'role', '');
      if (memberToken && role === 'shop') {
        this.init();
      }
    }
  }

  destroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  emitEvent(eventName, data) {
    if (this.socket && this.socket.connected) {
      this.socket.emit(eventName, data);
    }
  }

  login() {
    const memberToken = _.get(store.getState(), 'globalVariable.memberToken', '')
    if (this.socket && memberToken) {
      this.socket.emit('login', { memberToken }, data => {
        // console.log('socket: login', data);
      });
    }
  }
}

export default new SocketManager();
